import { createSlice } from '@reduxjs/toolkit';

import type { IGetGradeLevelInfoResponse } from '@/Module/Grade/Model/ApiModel';
import { getGradeDataAction, getStrategyLevelInfoAction } from '@/Module/Grade/Store/Action';
import { levelAdapter } from '@/Module/Grade/Store/Adapter';

const LevelSlice = createSlice({
  name: 'level',
  initialState: {
    isLoading: false,
    levels: levelAdapter.getInitialState(),
    levelGrade: null as IGetGradeLevelInfoResponse | null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getStrategyLevelInfoAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getStrategyLevelInfoAction.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getStrategyLevelInfoAction.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        levelAdapter.setAll(state.levels, payload);
      });
    builder.addCase(getGradeDataAction.fulfilled, (state, { payload }) => {
      // eslint-disable-next-line prefer-destructuring
      state.levelGrade = payload[0];
    });
  },
});
export default LevelSlice;
